export default [
  {
    for: 'category',
    actions: {
      read: true,
    },
  },
  {
    for: 'mlp',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'cmsState',
      'isMultiArtistPage',
      'options.customCSS',
      'options.customHeader',
      'options.customJs',
      'options.customContainerClass',
      'options.customContainerId',
      'options.customOptions',
      'options.template',
      'sso',
      'shopifyStore',
      'shopifyHasCartPage',
      'template',
      'theme',
      'thumbnail',
      'vhost',
      'version',
    ],
  },
  {
    for: 'content-item',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'mlp-page',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'artist',
    actions: {
      read: true,
    },
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
];
